/**
 * QR source persistence. First-touch and the most recent (registration) code
 * are kept independently so both survive sign-up and email confirmation.
 */
const KEY = "vitolier_qr_source";
const TTL_MS = 1000 * 60 * 60 * 24 * 30;

export interface QrSource { first: string; latest: string; method: "qr" | "link"; at: number; session: string }

function read(): QrSource | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as QrSource;
    if (!p.first || Date.now() - p.at > TTL_MS) return null;
    return p;
  } catch { return null; }
}

export function readQrSource(): QrSource | null { return read(); }

/** Store a scanned code. First touch never changes; latest always updates. Returns the session key. */
export function captureQrSource(code: string, method: "qr" | "link"): string {
  const existing = read();
  const session = existing?.session ?? (typeof crypto !== "undefined" && "randomUUID" in crypto ? crypto.randomUUID() : `s-${Date.now()}`);
  const next: QrSource = { first: existing?.first ?? code, latest: code, method, at: existing?.at ?? Date.now(), session };
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* ignore */ }
  return session;
}

export function clearQrSource() { try { localStorage.removeItem(KEY); } catch { /* ignore */ } }
